import type { ReactNode } from 'react';
import { Logo } from './Logo';
import { Pie } from './Pie';

export function PaginaAcceso({ children }: { children: ReactNode }) {
  return (
    <div className="pagina-acceso">
      <div className="pagina-acceso__logo">
        <Logo a="/" />
      </div>
      <main id="contenido" className="pagina-acceso__main">{children}</main>
      {/* El mismo pie que el sitio público: solo los paneles van sin él. */}
      <Pie />
    </div>
  );
}

interface PropsMarco {
  titulo: string;
  bajada?: ReactNode;
  /** Texto debajo de la tarjeta, por ejemplo "¿No tenés cuenta? Registrate". */
  pie?: ReactNode;
  children: ReactNode;
}

export function Marco({ titulo, bajada, pie, children }: PropsMarco) {
  return (
    <div className="marco">
      <h1 className="marco__titulo">{titulo}</h1>
      {bajada && <p className="marco__bajada">{bajada}</p>}
      <div className="marco__tarjeta">{children}</div>
      {pie && <div className="marco__pie">{pie}</div>}
    </div>
  );
}
